export default __webpack_public_path__ + "static/media/SANTIAGO MENA.fe1640ef.jpeg";